{
  "actionbar.actions": "Acțiuni",
  "actionbar.actionsAvailable": "Acțiuni disponibile.",
  "actionbar.clearSelection": "Goliți selecția",
  "actionbar.selected": "{count, plural, =0 {Niciunul selectat} one { # selectat} other {# selectate}}",
  "actionbar.selectedAll": "Toate elementele selectate",
  "actionbutton.pending": "în așteptare",
  "breadcrumbs.more": "Mai multe articole",
  "button.pending": "în așteptare",
  "calendar.invalidSelection": "{selectedCount, plural, one {Data selectată nu este disponibilă} other {Datele selectate nu sunt disponibile}}.",
  "combobox.loading": "Se încarcă...",
  "combobox.loadingMore": "Se încarcă mai multe...",
  "combobox.noResults": "Niciun rezultat",
  "contextualhelp.help": "Ajutor",
  "contextualhelp.info": "Informații",
  "datepicker.endTime": "Ora de sfârșit",
  "datepicker.startTime": "Ora de început",
  "datepicker.time": "Ora",
  "dialog.alert": "Alertă",
  "dialog.dismiss": "Revocare",
  "dropzone.replaceMessage": "Plasați fișierul pentru a înlocui",
  "inlinealert.informative": "Informații",
  "inlinealert.negative": "Eroare",
  "inlinealert.notice": "Avertisment",
  "inlinealert.positive": "Succes",
  "label.(optional)": "(opţional)",
  "label.(required)": "(obligatoriu)",
  "listview.loading": "Se încarcă...",
  "listview.loadingMore": "Se încarcă mai multe...",
  "menu.loading": "Se încarcă...",
  "menu.loadingMore": "Se încarcă mai multe...",
  "menu.moreActions": "Mai multe acțiuni",
  "menu.noResults": "Niciun rezultat",
  "menu.unavailable": "Indisponibil, extindeți pentru detalii",
  "notificationbadge.indicatorOnly": "Activitate nouă",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Se încarcă...",
  "picker.loadingMore": "Se încarcă mai multe...",
  "picker.placeholder": "Selectați…",
  "picker.selectedCount": "{count, plural, =0 {Niciun articol selectat} one {# articol selectat} other {# articole selectate}}",
  "sidepanel.collapse": "Restrângeți panoul lateral",
  "sidepanel.expand": " Extindeți panoul lateral",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Anulare",
  "table.drag": "Trageți",
  "table.editCell": "Editați celula",
  "table.loading": "Se încarcă...",
  "table.loadingMore": "Se încarcă mai multe...",
  "table.resizeColumn": "Redimensionați coloana",
  "table.save": "Salvați",
  "table.sortAscending": "Sortați crescător",
  "table.sortDescending": "Sortați descrescător",
  "tag.actions": "Acțiuni",
  "tag.hideButtonLabel": "Se afișează mai puțin",
  "tag.noTags": "Niciuna",
  "tag.showAllButtonLabel": "Se afișează tot ({tagCount, number})",
  "toast.clearAll": "Goliți tot",
  "toast.collapse": "Restrângeți",
  "toast.showAll": "Afișați tot",
  "treeview.loadingMore": "Se încarcă mai multe..."
}
